// LMS Templates translations for React Admin resource
export const lmsTemplatesResource = {
  name: 'LMS Templates',
  fields: {
    id: 'ID',
    name: 'Name',
    description: 'Description',
    type: 'Type',
    usage: 'Usage',
    status: 'Status',
    isActive: 'Active',
    isSystem: 'System Template',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    createdBy: 'Created By',
    actions: 'Actions',
    powerUtilizationPercent: 'Power Utilization',
    minPowerPerCharger: 'Minimum Power per Charger',
    powerReductionStep: 'Power Reduction Step',
    roundToNearest: 'Round to Nearest',
  },
};

// Custom LMS templates translations for components
export const lmsTemplates = {
  show: {
    title: 'LMS Template Details',
    subtitle: 'View and manage template configuration',
  },
  systemTemplate: 'System Template',
  create: {
    title: 'Create LMS Template',
    subtitle: 'Define a new power distribution template for load management',
    backToList: 'Back to LMS Templates',
  },
  edit: {
    title: 'Edit %{name}',
    subtitle: 'Modify the power distribution settings and configuration',
    backToList: 'Back to LMS Templates',
  },
  tabs: {
    general: 'General Information',
    danger: 'Danger Zone',
  },
  delete: {
    title: 'Delete LMS Template',
    content: 'This template will be permanently deleted',
    hasLoadGroupsContent: 'Cannot delete template that is in use by load groups',
    warning: 'Warning: This action cannot be undone',
    confirmMessage: 'You are about to delete the LMS template "%{name}"',
    typeToConfirm: 'To confirm deletion, please type "%{name}" below:',
    nameDoesNotMatch: 'Name does not match',
    button: 'Delete Template',
  },
  validation: {
    nameTooLong: 'Name must be less than 100 characters',
    descriptionTooLong: 'Description must be less than 500 characters',
    utilizationTooLow: 'Power utilization must be at least 50%',
    utilizationTooHigh: 'Power utilization cannot exceed 100%',
    minPowerTooLow: 'Minimum power must be at least 3 kW',
    minPowerTooHigh: 'Minimum power cannot exceed 22 kW',
    stepTooLow: 'Reduction step must be at least 0.1 kW',
    stepTooHigh: 'Reduction step cannot exceed 5 kW',
  },
  systemTemplateNote: 'System templates cannot be modified',
  notInUse: 'This template is not currently in use by any load groups',
  noLoadGroups: 'No load groups are currently using this template',
  loadGroups: 'load group |||| load groups',
  loadGroup: 'load group',
  loadGroupsPlural: 'load groups',
  loadGroupsUsing: 'Load Groups Using This Template',
  affectedLoadGroups: 'Affected Load Groups',
  types: {
    equal: 'Equal Distribution',
    priority: 'Priority Based',
    scheduled: 'Scheduled',
    dynamic: 'Dynamic',
  },
  configuration: 'Configuration',
  configExplanation: 'This template uses %{percent}% of available power and ensures each charger gets at least %{min} kW',
  filters: {
    search: 'Search by name or description',
    activeOnly: 'Active Only',
    systemOnly: 'System Templates',
  },
  actions: {
    clone: 'Clone Template',
    viewAffectedLoadGroups: 'View Affected Load Groups',
  },
  sections: {
    basic: 'Basic Information',
    configuration: 'Configuration',
    preview: 'Live Preview',
    usage: 'Usage Analytics',
    analytics: 'Usage & Analytics',
    metadata: 'Metadata',
    dangerZone: 'Danger Zone',
  },
  helpers: {
    name: 'Unique name for this template',
    description: 'Optional description of the template purpose',
    type: 'Template type determines the distribution algorithm',
    typeCannotChange: 'Template type cannot be changed while in use',
    powerUtilizationPercent: 'Percentage of total load group power to use. Reserve the rest as safety margin.',
    minPowerPerCharger: 'Minimum power each charger must receive before distribution',
    powerReductionStep: 'Step size for reducing power when needed',
    roundToNearest: 'Round power values to nearest increment for cleaner values',
  },
  equalDistribution: {
    description: 'Distributes available power equally among all active chargers',
  },
  preview: {
    title: 'Power Distribution Preview',
    scenario: 'Example Scenario:',
    totalPower: 'Total Power',
    utilization: 'Utilization',
    chargers: 'Active Chargers',
    distribution: 'Power Distribution',
    note: '%{unused} kW (%{percent}%) reserved as safety margin',
  },
  warnings: {
    inUse: 'This template is currently used by %{count} load groups',
    inUseWarning: 'This template is currently in use by %{count} load group(s). Any changes will affect their power distribution.',
    changesWillAffect: 'Changes will affect power distribution immediately',
    highUtilization: 'High power utilization may trigger circuit breakers',
  },
  stats: {
    loadGroups: 'Load Groups',
    totalPower: 'Total Power Managed',
    chargers: 'Chargers Affected',
    totalPowerDesc: 'Total power capacity managed',
    chargersDesc: 'Total chargers affected',
  },
  notifications: {
    created: 'LMS template created successfully',
    updated: 'LMS template updated successfully',
    deleted: 'LMS template deleted successfully',
    deleteError: 'Error deleting LMS template',
    cloned: 'LMS template cloned successfully',
  },
};